import { Action } from '@ngrx/store';

import { PersonaUser } from '®shared/auth';
import { UserRecord } from '®shared/user';

import { CurrentUserAndPermissions } from './current-user-and-permissions';

export enum CurrentUserActionTypes {
  REQUEST_CURRENT_USER = '[Current User] Request current user',
  STORE_CURRENT_USER = '[Current User] Store current user',
  UPDATE_CURRENT_USER_PROFILE = '[Current User] Update current user profile',
  STORE_ACCESS_TOKEN = '[Current User] Store access token',
  COMPLETE_REDIRECT_LOGIN = '[Current User] complete redirect login',
  COMPLETE_BREAKOUT_LOGIN = '[Current User] complete breakout login',
  COMPLETE_LTI_BREAKOUT_LOGIN = '[Current User] complete LTI breakout login',
  LOG_IN = '[Current User] log in via OAuth',
  LOG_IN_DURING_ROUTE_NAVIGATION = '[Current User] log in via OAuth during route navigation',
  LOG_OUT = '[Current User] log out',
}

export interface CurrentUserPayload {
  currentUser: CurrentUserAndPermissions;
}

export class RequestCurrentUserAction implements Action {
  readonly type = CurrentUserActionTypes.REQUEST_CURRENT_USER;
}

export class StoreCurrentUserAction implements Action {
  readonly type = CurrentUserActionTypes.STORE_CURRENT_USER;

  constructor(public payload: CurrentUserPayload) {}
}

export class UpdateCurrentUserProfileAction implements Action {
  readonly type = CurrentUserActionTypes.UPDATE_CURRENT_USER_PROFILE;

  constructor(public payload: { userRecord: UserRecord }) {}
}

export class StoreAccessTokenAction implements Action {
  readonly type = CurrentUserActionTypes.STORE_ACCESS_TOKEN;

  constructor(public payload: { accessToken: string }) {}
}

export class CompleteRedirectLoginAction implements Action {
  readonly type = CurrentUserActionTypes.COMPLETE_REDIRECT_LOGIN;
}

export class CompleteBreakoutLoginAction implements Action {
  readonly type = CurrentUserActionTypes.COMPLETE_BREAKOUT_LOGIN;

  constructor(public payload: { user: PersonaUser; target: string }) {}
}

export class CompleteLtiBreakoutLoginAction implements Action {
  readonly type = CurrentUserActionTypes.COMPLETE_LTI_BREAKOUT_LOGIN;

  constructor(public payload: { user: PersonaUser; target: string }) {}
}

export class LogInAction implements Action {
  readonly type = CurrentUserActionTypes.LOG_IN;
}

export class LogInDuringRouteNavigationAction implements Action {
  readonly type = CurrentUserActionTypes.LOG_IN_DURING_ROUTE_NAVIGATION;

  constructor(public payload: { stateUrl: string }) {}
}

export class LogOutAction implements Action {
  readonly type = CurrentUserActionTypes.LOG_OUT;
}

export type CurrentUserActions =
  | LogInAction
  | LogInDuringRouteNavigationAction
  | LogOutAction
  | RequestCurrentUserAction
  | StoreAccessTokenAction
  | StoreCurrentUserAction
  | UpdateCurrentUserProfileAction
  | CompleteRedirectLoginAction
  | CompleteBreakoutLoginAction;
